import { Injectable} from '@angular/core';
import { AuthHttp } from '../core/auth-http.service';
import {Observable} from 'rxjs/Observable';
import {Product} from './product.types';

@Injectable()
export class ProductService {

  constructor(private http: AuthHttp) {}

  getProducts(): Observable<Product[]> {
    return this.http.get('prd/product/admin')
      .map((response) => response.json());
  }
}



// WEBPACK FOOTER //
// ./src/app/product/product.service.ts